import { render, staticRenderFns } from "./AiQuestionaryBlock.vue?vue&type=template&id=63f8f010&scoped=true&"
import script from "./AiQuestionaryBlock.vue?vue&type=script&lang=ts&"
export * from "./AiQuestionaryBlock.vue?vue&type=script&lang=ts&"
import style0 from "./AiQuestionaryBlock.vue?vue&type=style&index=0&id=63f8f010&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f8f010",
  null
  
)

export default component.exports